module.exports = __webpack_public_path__ + "img/985F4028EDCDFA19BCC6718DA6706EDE.985f4028.png";